
export class UserImport  {

  id?: string | null;
  email?: string | null;
  firstName?: string | null;
  alias?: string | null;
  lastName?: string | null;
  companyId?: string | null;
  licenseId?: string | null;
  imageUrl?: string | null;
  companyName?: string | null;
  exists?: boolean | null;
  isSendEmail?: boolean = false;
}


